// Modules:
import React from 'react';

// Material UI:
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

const AgeGroupSelector = ({
    ageGroups,
    allAgeGroups,
    handleAgeGroupSelect,
}) => (
    <Grid container justify="center">
        <FormControl
            variant="standard"
            sx={{
                m: 1,
                margin: '0 auto',
                // Note: we omit the width property to allow the select to size based on content
            }}
        >
            <Select
                labelId="ages-multiple-select-label"
                id="ages-multiple-select"
                multiple
                value={ageGroups}
                onChange={handleAgeGroupSelect}
                input={<Input label="Age Group" />}
                MenuProps={{
                    sx: {
                        '& .MuiMenuItem-root.Mui-selected': {
                            backgroundColor: 'rgba(151, 182, 214, 0.5)',
                            '&.Mui-focusVisible': {
                                backgroundColor: 'rgba(151, 182, 214, 0.75)',
                                outline: '2px solid rgba(151, 182, 214, 0.9)',
                                outlineOffset: '-2px',
                            },
                            '&:hover': {
                                backgroundColor: 'rgba(151, 182, 214, 0.75)',
                            },
                        },
                    },
                }}
            >
                {allAgeGroups.map((group) => (
                    <MenuItem key={group.setName} value={group.label}>
                        {group.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText id="select-by-age-text">
                Select age groups
            </FormHelperText>
        </FormControl>
    </Grid>
);

export default AgeGroupSelector;
